import React, { useState } from 'react';
import classNameBind from 'classnames/bind';
import styles from './CardAccordion.module.css';
import Icon from '../../../Icon';

const bindClasses = classNameBind.bind(styles);

const CardAccordion = ({
  children,
  clickableContent,
  clickableContentOnClick,
  openInitialState,
  setRef,
  dataId,
  subdued,
}) => {
  const [isOpened, setOpen] = useState(openInitialState);

  return (
    <div
      className={bindClasses('wrapper', { subdued })}
      data-ppuc-id={dataId}
    >
      <div
        className={bindClasses('clickableElement', { opened: isOpened })}
        onClick={() => {
          clickableContentOnClick(!isOpened);
          setOpen(!isOpened);
        }}
        ref={setRef}
        role="button"
        tabIndex={-1}
      >
        <div className={bindClasses('button')}>
          <Icon
            name="chevron-right"
            size="medium"
            className={bindClasses(
              'rotate-transition',
              {
                'rotate-down': isOpened,
                'rotate-up': !isOpened,
              },
            )}
          />
        </div>
        <div>
          {clickableContent}
        </div>
      </div>
      {isOpened && (
        <div className={bindClasses('expandableContent')}>
          {children}
        </div>
      )}
    </div>
  );
};

CardAccordion.defaultProps = {
  children: null,
  clickableContent: null,
  clickableContentOnClick: () => {},
  openInitialState: false,
  setRef: null,
  subdued: false,
  dataId: 'Card.Accordion',
};

CardAccordion.displayName = 'Card.Accordion';

export default CardAccordion;
